import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import rafSchedule from 'raf-schd';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { pluginFactory } from '@atlaskit/editor-common/utils';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
var pluginKey = new PluginKey('editorDisabledPlugin');
function reducer(_pluginState, meta) {
  return meta;
}
var _pluginFactory = pluginFactory(pluginKey, reducer),
  getPluginState = _pluginFactory.getPluginState;

/*
Stores the state of the editor enabled/disabled for panel and floating
toolbar to subscribe to through useSharedPluginState. Otherwise the NodeViews
won't re-render when it changes.
*/
function createPlugin(dispatch, options) {
  var scheduleEditorDisabledUpdate = rafSchedule(function (view) {
    if (getPluginState(view.state).editorDisabled !== !view.editable) {
      var disabledMeta = {
        editorDisabled: !view.editable
      };
      var tr = view.state.tr.setMeta(pluginKey, disabledMeta).setMeta('editorDisabledPlugin', disabledMeta);
      tr.setMeta('isLocal', true);
      view.dispatch(tr);
    }
  });
  return new SafePlugin({
    key: pluginKey,
    state: {
      init: function init() {
        var _options$initialDisab;
        return {
          editorDisabled: (_options$initialDisab = options === null || options === void 0 ? void 0 : options.initialDisabledState) !== null && _options$initialDisab !== void 0 ? _options$initialDisab : false
        };
      },
      apply: function apply(tr, pluginState) {
        var meta = tr.getMeta(pluginKey);
        if (meta) {
          return pluginState.editorDisabled !== meta.editorDisabled ? _objectSpread(_objectSpread({}, pluginState), meta) : pluginState;
        }
        return pluginState;
      }
    },
    view: function view(_view) {
      // schedule on mount
      scheduleEditorDisabledUpdate(_view);
      return {
        update: function update(view) {
          scheduleEditorDisabledUpdate(view);
        },
        destroy: function destroy() {
          scheduleEditorDisabledUpdate.cancel();
        }
      };
    }
  });
}

/**
 * Editor disabled plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 *
 * @param options - Plugin configuration options
 * @returns EditorDisabledPlugin
 *
 * @example
 * ```typescript
 * // Basic usage
 * .add(editorDisabledPlugin)
 *
 * // With initial disabled state
 * .add(editorDisabledPlugin, { initialDisabledState: true })
 * ```
 */
export var editorDisabledPlugin = function editorDisabledPlugin(_ref) {
  var _ref$config = _ref.config,
    options = _ref$config === void 0 ? {} : _ref$config,
    api = _ref.api;
  return {
    name: 'editorDisabled',
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return {
          editorDisabled: false
        };
      }
      var pluginState = pluginKey.getState(editorState);
      if (!pluginState) {
        return {
          editorDisabled: false
        };
      }
      return pluginState;
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'editorDisabled',
        plugin: function plugin(_ref2) {
          var dispatch = _ref2.dispatch;
          return createPlugin(dispatch, options);
        }
      }];
    }
  };
};